module.exports = __webpack_public_path__ + "media/images/accommodation_capacity-f375829028dbe3e3b39d1703a44678bb.png";